import _get from 'lodash/get';
import {
  FormTemplateQuestionFieldOptionsValidityHintEnum,
  TaskTimelineCompletionGroupByEnum,
  TaskTimelineFrameEnum,
  TaskTimelineGroupByEnum,
  TasksTimelineReportCreateInput,
} from 'graphql-common';
import TasksFilterFieldNames from '@lib/enums/fieldNames/tasksFilterFieldNames';
import { Values } from '@lib/interfaces/form';
import { FieldNames, FormTypeValue } from 'components/GenerateReportForm/types';
import { SelectOption } from '@lib/components/Select/types';

type Args = {
  basePeriodEndParam: string;
  basePeriodStartParam: string;
  completionGroupBy: TaskTimelineCompletionGroupByEnum;
  filterParams: Values;
  taskIds: string[];
  values: Values;
};

export default function getPreparedReportDataFromValues(
  args: Args,
): TasksTimelineReportCreateInput {
  const {
    basePeriodEndParam,
    basePeriodStartParam,
    completionGroupBy,
    filterParams,
    taskIds,
    values,
  } = args;
  const formType = _get(values, `${FieldNames.FormType}.value`) as string;
  const recipients = _get(
    values,
    FieldNames.RecipientIds,
    [],
  ) as SelectOption[];
  const message = _get(values, FieldNames.Message) as string | null;
  const period = _get(values, FieldNames.Period, [
    basePeriodStartParam,
    basePeriodEndParam,
  ]) as string[];
  const timeFrame = _get(
    filterParams,
    TasksFilterFieldNames.TimelineView,
  ) as TaskTimelineFrameEnum;
  const validityHints = _get(
    filterParams,
    TasksFilterFieldNames.ValidityHints,
    [],
  ) as SelectOption[];
  return {
    params: {
      timeFrame,
      queryData: {
        dateRange: { startDate: period[0], endDate: period[1] },
        groupBy: TaskTimelineGroupByEnum.Day,
        validityHints: validityHints.map(
          ({ value }) =>
            value as FormTemplateQuestionFieldOptionsValidityHintEnum,
        ),
      },
      completionGroupBy,
      taskIds,
    },
    delivery:
      formType === FormTypeValue.Email
        ? {
            recipientIds: recipients.map(({ value }) => String(value)),
            message: message || undefined,
          }
        : undefined,
  };
}
